import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

export default function SEO({
  title,
  description,
  keywords = "software development,Web Design, web development, mobile app development, UAE, Dubai, Abu Dhabi, Sharjah, custom software, enterprise solutions, startup development",
  ogImage = "https://res.cloudinary.com/due4nhetn/image/upload/v1752608751/Untitled_design_88_1_xear67.webp",
  ogType = "website",
  canonical
}: SEOProps) {
  const fullTitle = title.includes("Kecly") ? title : `${title} | Kecly`;
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : 'https://www.kecly.com');

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Kecly",
    "description": "Professional web design and development services",
    "url": "https://www.kecly.com",
    "logo": "https://www.kecly.com/logo.png",
    "image": "https://www.kecly.com/logo.png",
    "telephone": "+971-58-248-1443",
    "priceRange": "$5000",
    "sameAs": [
      "https://www.facebook.com/keclyofficial/",
      "https://www.linkedin.com/company/kecly"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Arwani Building, Industrial Area 3",
      "addressLocality": "Dubai",
      "addressRegion": "UAE",
      "postalCode": "00000",
      "addressCountry": "AE"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Web Design Services",
      "itemListElement": [
        {
          "@type": "OfferCatalog",
          "name": "Web Design",
          "url": "https://www.kecly.com/web-design-development"
        }
      ]
    }
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} data-react-helmet="true" />
      <meta name="keywords" content={keywords} data-react-helmet="true" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-react-helmet="true" />
      <meta property="og:url" content={url} data-react-helmet="true" />
      <meta property="og:title" content={fullTitle} data-react-helmet="true" />
      <meta property="og:description" content={description} data-react-helmet="true" />
      <meta property="og:image" content={ogImage} data-react-helmet="true" />
      <meta property="og:site_name" content="Kecly" data-react-helmet="true" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-react-helmet="true" />
      <meta property="twitter:url" content={url} data-react-helmet="true" />
      <meta property="twitter:title" content={fullTitle} data-react-helmet="true" />
      <meta property="twitter:description" content={description} data-react-helmet="true" />
      <meta property="twitter:image" content={ogImage} data-react-helmet="true" />
      
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" data-react-helmet="true" />
      <meta name="author" content="Kecly" data-react-helmet="true" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-react-helmet="true" />
      <link rel="canonical" href={url} data-react-helmet="true" />
      
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
